export default "__VITE_ASSET__lSoPgqfe__"